import { ModulesMap } from '@/config/data/modulesMaps'

import ApiModule from '@/services/apiModule.js'

export default class MaterialsCategoriesApi extends ApiModule {
	constructor() {
		super(ModulesMap.MATERIALS_CATEGORIES, {
			entity: 'materials_categories',
		})
	}
}